import {default as classnames, default as classNames} from "classnames";
import {ReactNode} from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {ActionButtonProps, ActionLinkProps} from "@/components/quickActionsBar/common.tsx";

interface Props {
  id: string;
  actions: ReactNode[];
}

export const QuickActionsBar = ({id, actions}: Props) => {
  return (
    <span className="d-flex justify-content-end align-items-center text-dark">
      {actions.map((item, idx) => (
        <span key={`${id}-quick-action-${idx}`}>{item}</span>
      ))}
    </span>
  );
};

export const IconLinkAction = ({tooltip, children, className, target, rel, to}: ActionLinkProps) => (
  // trigger={["hover", "hover"]} is intentional to trick compiler into ignoring missing "focus" parameter
  // focus parameter should help keyboard/mobile users to see a tooltip. Our UX is not that friendly yet
  // and react-boostrap is too vocal if you ignore focus parameter
  <OverlayTrigger
    trigger={["hover", "hover"]}
    placement="top"
    overlay={(props) => (
      <Tooltip id="tooltip-link-icon" {...props}>
        {tooltip}
      </Tooltip>
    )}
  >
    <Link
      target={target}
      rel={rel}
      to={to!}
      className={classnames("btn btn-sm btn-outline-light border-0 text-dark", className)}
    >
      {children}
    </Link>
  </OverlayTrigger>
);

export const ButtonAction = ({children, tooltip, className, onClick}: ActionButtonProps) => (
  <OverlayTrigger
    trigger={["hover", "hover"]}
    placement="top"
    overlay={(props) => (
      <Tooltip {...props}>
        <>{tooltip}</>
      </Tooltip>
    )}
  >
    <Button variant={"ghost"} onClick={onClick} className={classNames("px-1", className)}>
      {children}
    </Button>
  </OverlayTrigger>
);

export const ExternalLinkAction = ({children, tooltip, className, to, rel, target}: ActionLinkProps) => (
  <OverlayTrigger
    trigger={["hover", "hover"]}
    placement="top"
    overlay={(props) => <Tooltip {...props}>{tooltip}</Tooltip>}
  >
    <a
      href={to}
      rel={rel}
      target={target}
      className={classnames("btn btn-sm btn-outline-light border-0 text-dark", className)}
    >
      {children}
    </a>
  </OverlayTrigger>
);
